import { Actions } from './reassignConnectionsModal.types'

const messages = {
  cancel: 'Cancel',
  chooseAction: 'Choose action',
  connection: 'connection',
  connections: 'connections',
  confirm: 'Confirm',
  errorTitle: 'Error Updating Connections',
  errorDesc:
    'There was an error updating the connections, please try again later.',
  has: 'has',
  modalTitle: 'Reassign {amount} Connections',
  nActiveConnections: '{amount} active connections.',
  newSalesRep: 'New Sales Rep',
  reassignSuccessTitle: 'Connections Reassigned Successfully',
  reassignSuccessDesc: '{amount} connections moved from {old} to {new}',
  removeSuccessTitle: 'Connections Removed Successfully',
  removeSuccessDesc:
    '{old} has been removed as the default sales rep on {amount} connections.',
  selectSalesRep: 'Select Sales Rep',
  removeThisRepFromNConnections:
    'Remove this rep from all {amount} connections.',
  transferNConnections:
    'Transfer all {amount} connections to a different sales rep.',
  warning: 'Warning',
  warningDesc:
    '{amount} connections will have no assigned sales rep after this action',
} as const

export const ACTION_LABELS = {
  [Actions.REASSIGN]: 'Reassign to Another Sales Rep',
  [Actions.REMOVE]: 'Remove from All Connections',
} as const

export default messages
